import React from 'react';
import PropTypes from 'prop-types';

import DigitalBundlePhotoPreview from './DigitalBundlePhotoPreview';
import withModal from '../../../../global/modal/withModal';

export const DIGITAL_BUNDLE_PHOTO_PREVIEW_MODAL =
  'modal/DIGITAL_BUNDLE_PHOTO_PREVIEW';

const propTypes = {
  actionProps: PropTypes.shape({
    purchasedDigitalBundle: PropTypes.shape({
      id: PropTypes.string,
    }),
    basename: PropTypes.string,
  }),
};

const DigitalBundlePhotoPreviewModal = ({ actionProps, ...props }) => {
  const { purchasedDigitalBundle, basename } = actionProps ?? {};

  return (
    <DigitalBundlePhotoPreview
      purchasedDigitalBundle={purchasedDigitalBundle}
      basename={basename}
      {...props}
    />
  );
};

DigitalBundlePhotoPreviewModal.propTypes = propTypes;

export default withModal(DigitalBundlePhotoPreviewModal, {
  name: DIGITAL_BUNDLE_PHOTO_PREVIEW_MODAL,
  size: 'md',
  type: 'full',
});
